import { Component } from '@angular/core';

@Component({
    selector: 'backend-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.css'],
    standalone: false
})
export class OverviewComponent {

}
